<div id="map" class="map" leaflet [leafletOptions]="mapOptions" [leafletLayers]="layers"
[leafletLayersControl]="layersControl" (leafletMapReady)="onMapReady($event)">
</div>
